import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import LuxeLayout from "@/components/luxe/LuxeLayout";
import LuxeHome from "@/pages/luxe/LuxeHome";
import LuxeAbout from "@/pages/luxe/LuxeAbout";
import LuxeServices from "@/pages/luxe/LuxeServices";
import LuxeContact from "@/pages/luxe/LuxeContact";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route element={<LuxeLayout />}>
            <Route path="/" element={<LuxeHome />} />
            <Route path="/about" element={<LuxeAbout />} />
            <Route path="/services" element={<LuxeServices />} />
            <Route path="/contact" element={<LuxeContact />} />
            <Route path="*" element={<LuxeHome />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-right" />
    </div>
  );
}

export default App;
